
import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import Groups from '../../../group/Groups';
import { emptyUUID } from '../../../../util';
import { GroupMaintenanceExtension, GroupMaintenanceExtensionUiClient, IGroupMaintenanceExtension } from '../../../backend/backendapi';
import { initClient } from '../../../../api';
import GroupMaintenanceExtensionStore from '../../../../stores/GroupMaintenanceExtensionStore';
import GroupsForMaintenanceEditModal from './GroupsForMaintenanceEditModal.vue';

@Component({
  components: {
    GroupsForMaintenanceEditModal,
    Groups,
  },
})
export default class GroupsForMaintenance extends Vue {
  private readonly api = initClient(GroupMaintenanceExtensionUiClient);
  readonly store = new GroupMaintenanceExtensionStore();

  GroupMaintenanceExtension = GroupMaintenanceExtension;
  
  get groups(): GroupMaintenanceExtension[] {
    return this.store.groupMaintenanceExtensions.filter(e => !e.group?.archived);
  }

  async mounted(): Promise<void> {
    await this.store.reload();
  }

  initGroup(): GroupMaintenanceExtension {
    return GroupMaintenanceExtension.fromJS({
      id: emptyUUID(),
      groupId: emptyUUID(),
      group: (this.$refs.groups as Groups).groupInitFunctionInternal(),
      cellScopeVisibilities: [],
    } as IGroupMaintenanceExtension);
  }

  async saveGroup(group: GroupMaintenanceExtension): Promise<GroupMaintenanceExtension> {
    let res: GroupMaintenanceExtension;
    if (!group.id || group.id === emptyUUID()) {
      res = await this.api.create(group);
    } else {
      res = await this.api.update(group);
    }
    this.store.rememberGroupMaintenanceExtension(res);
    return res;
  }

  async deleteGroup(group: GroupMaintenanceExtension): Promise<void> {
    await this.api.delete(group.id);
    this.store.forgetGroupMaintenanceExtension(group);
  }
}
